module.exports = __webpack_public_path__ + "img/Gears_of_leo.3cc2bc0b.png";